import { z } from 'zod';

function defaultWhenNullish<T extends z.ZodTypeAny, S>(schema: T, fallback: S) {
  return schema.nullish().transform(value => value ?? fallback);
}

export { defaultWhenNullish };
